export { SEO, default } from './SEO';
export type { SEOProps } from './SEO';

// SEO utility functions
export const generatePageTitle = (pageTitle: string, siteName = 'EZTopup') => {
  return `${pageTitle} | ${siteName}`;
};

export const generateMetaDescription = (content: string, maxLength = 160) => {
  return content.length > maxLength ? content.substring(0, maxLength - 3) + '...' : content;
};

export const generateKeywords = (baseKeywords: string[], pageKeywords: string[] = []) => {
  return [...baseKeywords, ...pageKeywords].join(', ');
};

// Common SEO constants
export const BASE_KEYWORDS = [
  'mobile topup',
  'data packages',
  'e-gift cards',
  'Myanmar',
  'digital recharge',
  'phone credit',
  'instant topup',
  'MPT',
  'U9',
  'Atom',
  'ATOM',
  'MyTel',
  'auto topup',
  'ez auto topup',
  'coupon topup',
  'ez coupon topup',
  'merchant topup',
  'ez topup merchant',
  'affiliate program',
  'ez affiliate',
  'ဖုန်းငွေဖြည့်',
  'ဒေတာပက်ကေ့ချ်',
  'အော်တိုတော့ပ်အပ်',
  'ကူပွန်တော့ပ်အပ်',
  'မာချန့်',
  'အဖီးလိယိတ်',
];

export const SITE_CONFIG = {
  siteName: 'EZTopup',
  siteUrl: 'https://eztopup.com.mm/',
  secondarySiteUrl: 'https://myeztopup.com/',
  defaultImage: '/logo.svg',
  twitterHandle: '@myeztopup',
  locale: 'en_US',
  alternateLocale: 'my_MM',
};
